import type { SectionId } from '@/access/sections'

const raw = import.meta.env

function parseFeatures(value: string | undefined): ReadonlySet<SectionId> | null {
  const ids = (value ?? '')
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean)
  return ids.length ? new Set(ids as SectionId[]) : null
}

/** Per-environment config. Public values only (see .env.* files). */
export const env = {
  appEnv: raw.VITE_APP_ENV,
  apiBaseUrl: raw.VITE_API_BASE_URL.replace(/\/$/, ''),
  /** Sections enabled in this env; null = all. Lets sections ship dark until their API lands. */
  features: parseFeatures(raw.VITE_FEATURES),
  sentryDsn: raw.VITE_SENTRY_DSN || undefined,
  commitSha: __COMMIT_SHA__,
} as const
